import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Operand, OperatorType} from '@em/shared/mapping-engine/domain-models';

@Component({
  selector: 'em-operand-icon',
  templateUrl: './operand-icon.component.html',
  styleUrls: ['./operand-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmOperandIconComponent {
  @Input() operand: Operand | undefined | null;
  @Input() operatorType: OperatorType | undefined | null;
  @Input() isCustom = false;
}
